import { render } from "./AudiencesListItem.vue?vue&type=template&id=494899d2"
import script from "./AudiencesListItem.vue?vue&type=script&lang=js"
export * from "./AudiencesListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__